import axios from 'axios';

const baseUrl = 'https://dev-exporters.wiwi.services';

export const http = axios.create({
  baseURL: baseUrl,
});

export default http;
